/**
 * setShareContent.js
 * Written by: Alex Kasemir
 */

import { getWeightedRandom } from 'utils';

export const setShareContentStart = () => ({
  type: `SET_SHARE_CONTENT_START`,
});

export const setShareContentSuccess = (kind) => ({
  type: `SET_SHARE_CONTENT_SUCCESS`,
  kind,
});

export const setShareContentFailure = (error) => ({
  type: `SET_SHARE_CONTENT_FAILURE`,
  error,
});

const CONTENT_TYPES = {
  leaderboard: 5,
  question: 5,
  badge: 1,
};

/**
 * Description of the setShareContent action
 */
export const setShareContent = () => {
  return (dispatch) => {
    dispatch(setShareContentStart());
    const contentType = getWeightedRandom(CONTENT_TYPES);
    dispatch(setShareContentSuccess(contentType));
    return contentType;
  };
};

export default setShareContent;
